import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../../layout/component/ContentBox'
import Row from '../../../../bootstrap/component/Row'
import Column from '../../../../bootstrap/component/Column'
import Table from '../../../../form/component/Table'
import { lifecycle } from 'recompose'

const getColumnList = () => {
    const columnList = []

    columnList.push({
        property: 'manufacturer',
        header: 'Manufaturer',
        renderer: foilSupply => {
            return foilSupply.foilName.manufacturer
        },
        sortValue: foilSupply => {
            return foilSupply.foilName.manufacturer
        },
    })

    columnList.push({
        property: 'thickness',
        header: 'Thickness',
        renderer: foilSupply => {
            return foilSupply.foilName.thickness
        },
        sortValue: foilSupply => {
            return foilSupply.foilName.thickness
        },
    })

    columnList.push({
        property: 'type',
        header: 'Type',
        renderer: foilSupply => {
            return foilSupply.foilName.type
        },
        sortValue: foilSupply => {
            return foilSupply.foilName.type
        },
    })

    columnList.push({
        property: 'lot',
        header: 'Lot',
    })

    columnList.push({
        property: 'dateSetToActive',
        header: 'Date set to Active',
        comparator: Table.dateComparator('dateSetToActive'),
        renderer: Table.dateTimeRenderer('dateSetToActive'),
    })

    columnList.push({
        property: 'dateSetToInactive',
        header: 'Date set to Inactive',
        comparator: Table.dateComparator('dateSetToInactive'),
        renderer: Table.dateTimeRenderer('dateSetToInactive'),
    })

    columnList.push({
        property: 'status',
        header: 'Status',
    })

    return columnList
}

const FoilInfoTable = ({ foilList, tableSetting, changeTableSetting }) => {
    const columnList = getColumnList()

    return (
        <ContentBox title="Foil Information">
            <Row>
                <Column size={12}>
                    <Table
                        columnList={columnList}
                        rowList={foilList}
                        changeTableSetting={changeTableSetting}
                        tableSetting={tableSetting}
                        idProperty="id"
                    />
                </Column>
            </Row>
        </ContentBox>
    )
}


FoilInfoTable.propTypes = {
    foilList: PropTypes.array.isRequired,
    tableSetting: PropTypes.object.isRequired,
    changeTableSetting: PropTypes.func.isRequired,
    getFoilList: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.getFoilList()
    },
})(FoilInfoTable)




// WEBPACK FOOTER //
// ./src/modules/foil/component/overview/info-table/FoilInfoTable.js